var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SimpleFieldList',{attrs:{"disabled":_vm.disabled,"operators":_vm.operators,"spr":_vm.tenderContactPersons,"value":_vm.mutableValue},on:{"update:value":function($event){_vm.mutableValue=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }